import RandomQuestionModal from "../components/organisms/RandomQuestionModal";
import PaymentProveModal from "../components/organisms/PaymentProveModal";
import PayScheduledPaymentModal from "../components/organisms/PayScheduledPaymentModal";
import PayDebtModal from "../components/organisms/PayDebtModal";
import VerifyPaymentModal from "../components/organisms/VerifyPaymentModal";
import ErrorModal from "../components/organisms/ErrorModal";
import LoginExpiredModal from "../components/organisms/LoginExpiredModal";
import PaymentArrangementModal from "../components/organisms/PaymentArrangementModal";
import SubmitPaymentArrangementModal from "../components/organisms/SubmitPaymentArrangementModal";
import InvoiceTable from "../components/molecules/InvoiceTable";
import EditEmailModal from "../components/organisms/EditEmailModal";
import TokenExpiredModal from "../components/organisms/TokenExpiredModal";
import VerifyDateOfBirthModal from "../components/organisms/VerifyDateOfBirthModal";
import LanguageModal from "../components/organisms/LanguageModal";
import PaymentArrangementStatusModal from "../components/organisms/PaymentArrangementStatusModal";
import ObjectionModal from "../components/organisms/ObjectionModal";
import DebtCollectorModal from "../components/organisms/DebtCollectorModal";
import SelectDossierTypeModal from "../components/organisms/SelectDossierTypeModal";

export const openRandomQuestionModal = (showModal, objectionIsEnabled) => {
  showModal(RandomQuestionModal, {
    title: "modals.generic_question",
    noGutter: true,
    primary: true,
    height: "910px",
    objectionIsEnabled: objectionIsEnabled,
  });
};

export const openPaymentProveModal = showModal => {
  showModal(PaymentProveModal, {
    title: "modals.payment_proof",
    primary: true,
    noGutter: true,
    height: "780px",
  });
};

export const openPayScheduledPaymentModal = (showModal, period) => {
  showModal(PayScheduledPaymentModal, {
    title: "modals.confirm_payment_arrangement",
    noGutter: true,
    primary: true,
    isCompact: true,
    period,
  });
};

export const openPayDebtModal = (showModal, select = null) => {
  showModal(PayDebtModal, {
    title: "modals.payment_request",
    select: select,
    noGutter: true,
    primary: true,
    isCompact: true,
    borderRadius: true,
  });
};

export const openVerifyPaymentModal = showModal => {
  showModal(VerifyPaymentModal, {
    title: "modals.verify_payment",
    isCompact: true,
    primary: true,
    closeable: false,
    noGutter: true,
  });
};

export const openLoginExpiredModal = (showModal, message) => {
  showModal(LoginExpiredModal, {
    title: "modals.session_almost_expired",
    closeable: false,
    message: message,
  });
};

export const openErrorModal = (showModal, message) => {
  showModal(ErrorModal, {
    title: "modals.error",
    closeable: false,
    message: message,
  });
};

export const openObjectionModal = (
  showModal,
  dossier,
  message,
  objectionFallbackUrl,
  objectionUrl
) => {
  showModal(ObjectionModal, {
    title: "modals.objection",
    closeable: true,
    primary: true,
    message: message,
    noGutter: true,
    dossier: dossier,
    objectionFallbackUrl: objectionFallbackUrl,
    objectionUrl: objectionUrl,
  });
};

export const openDebtCollectorModal = (showModal, message) => {
  showModal(DebtCollectorModal, {
    title: "modals.debt_collector",
    closeable: false,
    primary: true,
    message: message,
    isCompact: true,
    noGutter: true,
  });
};

export const openPaymentArrangementModal = (
  showModal,
  request,
  forMultipleDossiers,
  totalBalance,
  minimumMonthlyPayment
) => {
  showModal(PaymentArrangementModal, {
    title: "modals.start_payment_arrangement",
    primary: true,
    noGutter: true,
    isCompact: true,
    height: "auto",
    oldRequest: request,
    forMultipleDossiers: forMultipleDossiers,
    totalBalance: totalBalance,
    minimumMonthlyPayment: minimumMonthlyPayment,
  });
};

export const openSelectDossierTypeModal = (
  showModal,
  defaultValue = "current",
  totalBalance,
  minimumMonthlyPayment
) => {
  showModal(SelectDossierTypeModal, {
    title: "modals.select_dossier_type",
    noGutter: true,
    primary: true,
    isCompact: true,
    height: "fit-content",
    defaultValue,
    totalBalance,
    minimumMonthlyPayment,
  });
};

export const openSubmitPaymentArrangementModal = (
  showModal,
  request,
  hasMultipleDossiers
) => {
  showModal(SubmitPaymentArrangementModal, {
    title: "modals.request_payment_arrangement",
    noGutter: true,
    primary: true,
    isCompact: true,
    height: "auto",
    request: request,
    hasMultipleDossiers: hasMultipleDossiers,
  });
};

export const openInvoiceTableModal = (showModal, invoices) => {
  showModal(InvoiceTable, {
    title: "modals.invoices",
    noGutter: true,
    primary: true,
    height: "800px",
    invoices,
  });
};

export const openEditEmailModal = showModal => {
  showModal(EditEmailModal, {
    title: "modals.edit_email",
    primary: true,
    isCompact: true,
  });
};

export const openRequestedPaymentArrangementModal = (showModal, request) => {
  showModal(PaymentArrangementStatusModal, {
    title: "modals.submitted_payment_arrangement",
    primary: true,
    isCompact: true,
    isPending: true,
    request,
  });
};

export const openPaymentArrangementAcceptedModal = (showModal, request) => {
  showModal(PaymentArrangementStatusModal, {
    title: "modals.confirmed_payment_arrangement",
    primary: true,
    isCompact: true,
    isAccepted: true,
    request,
  });
};

export const openTokenExpiredModal = showModal => {
  showModal(TokenExpiredModal, {
    title: "modals.session_expired",
    primary: true,
    isCompact: true,
    noGutter: true,
    closeable: false,
  });
};

export const openDateOfBirthValidationModal = showModal => {
  showModal(VerifyDateOfBirthModal, {
    title: "modals.confirm_birthdate",
    primary: true,
    isCompact: true,
    noGutter: true,
  });
};

export const openLanguageModal = showModal => {
  showModal(LanguageModal, {
    title: "modals.choose_language",
    primary: true,
    isCompact: true,
    noGutter: true,
  });
};
